import './OfferSnippetVasBlock.css';

import React from 'react';
import { Button, Typography } from '@vtblife/uikit';
import { Size } from '@vtblife/uikit/legacy';

import classname from '@search/classname/src';
import Icon from '@vtblife/uikit-icons';

import {
    OfferPlacementDraftOfferVasState,
    VasStatusEnum,
    VasConditionEnum,
    VasEnum
} from '@search/graphql-typings';
import {
    useOfferCardVasBlock
} from '@search/vtbeco-frontend-core/view/common/components/OfferCardVasBlock/useOfferCardVasBlock';

const cn = classname.bind(null, 'ClOfferSnippetVas');

const vasTypeMap: Record<VasEnum, string> = {
    [VasEnum.Top]: 'ТОП размещение',
    [VasEnum.Priority]: 'Приоритет',
    [VasEnum.Highlight]: 'Выделение цветом',
    [VasEnum.ValueNotSet]: ''
};

export const OfferSnippetVasDescription = () => (
    <div className={cn('description')}>
        Увеличьте количество просмотров, подключив продвижение.
        Ваше объявление станет крупнее&nbsp;и&nbsp;выше&nbsp;любых&nbsp;бесплатных на страницах&nbsp;поиска.
    </div>
);

export const OfferSnippetStatsBlock = ({ offerViews, phoneViews }: {
    offerViews: number;
    phoneViews: number;
}) => {
    return (
        <div className={cn('viewStats')}>
            <div className={cn('offerViews')}>
                <Icon name='eye' size='s' />
                <span>
                    {`Просмотры: ${offerViews ?? 0}`}
                </span>
            </div>
            <div className={cn('phoneViews')}>
                <Icon name='phone-eye' size='s' />
                <span>
                    {`Показы телефона: ${phoneViews ?? 0}`}
                </span>
            </div>
        </div>
    );
};

export const ClOfferSnippetVasItem = ({ vas } : { vas?: OfferPlacementDraftOfferVasState | null }) => {
    return (vas ? <div className={cn('vas')}>
        <div className={cn('title')}>
            <Typography bold variant='primary'>{vasTypeMap[vas.vas!]}</Typography>
        </div>
        <span className={cn('text')}>
            {getVasStatusText(vas)}
            {vas.status === VasStatusEnum.VasStatusRequested ? (
                <div>
                    <button
                        type='button'
                        onClick={() => null}
                        className={cn('repeat-btn')}
                    >
                        Повторить
                    </button>
                </div>
            ) : null}
        </span>
    </div> : null);
};

export const OfferSnippetPromoteBtn = ({ offerId, regionId, userPhone, gtmChoiceOption } : {
    regionId: number;
    offerId: string;
    userPhone?: string;
    gtmChoiceOption: string;
}) => {
    const { handleBuyVas } = useOfferCardVasBlock({
        offerId,
        regionId,
        userPhone,
        gtmChoiceOption
    });

    return (
        <Button
            onClick={handleBuyVas}
            fullWidth
            size={Size.Small}
            variant='secondary'
        >
            Подключить продвижение
        </Button>
    );
};

function getVasStatusText(vas: OfferPlacementDraftOfferVasState): string {
    if (vas.status === VasStatusEnum.VasStatusRequested) return 'Оплата в процессе';
    if (vas.condition === VasConditionEnum.Inactive) return 'Приостановлено';

    return `Активно до ${vas.until!.formattedFull}`;
}
